import React from 'react';
import '../Dashboard.css'
import BookRow from './BookRow';
import { useIntl } from 'react-intl';

/**
 * Live bid/ask depth for the SELECTED chart symbol (props.symbol).
 * This is NOT the user's open orders — it is the market order book.
 *
 * props:
 * - data: the live book map keyed by symbol
 * - symbol: the currently charted symbol to follow
 * - cols: optional grid column classes for the wrapper (default sm-12 md-6)
 */
function Book(props) {

    const { formatMessage } = useIntl();
    const t = (id) => formatMessage({ id });

    const symbol = props.symbol;
    const bookData = symbol && props.data ? props.data[symbol] : null;

    return (<React.Fragment>
        <div className={props.cols || "col-sm-12 col-md-6 mb-4"}>
            <div className="card border-0 shadow h-100">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h2 className="fs-5 fw-bold mb-0">
                        {t('dashboard.orderBook')} — {symbol}
                    </h2>
                    <span className="badge bg-secondary">{t('dashboard.book.marketDepth')}</span>
                </div>
                <div className="table-responsive divScroll">
                    <table className="table align-items-center table-flush table-sm table-hover tableFixHead">
                        <thead className="thead-light">
                            <tr>
                                <th className="border-bottom col-6" scope="col">{t('common.symbol')}</th>
                                <th className="border-bottom col-6" scope="col">{t('dashboard.book.price')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                bookData
                                    ? <BookRow symbol={symbol} data={bookData} />
                                    : (<tr><td colSpan={2} className="text-muted">{t('common.loading')}</td></tr>)
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </React.Fragment>);
}

export default Book;
